<template>
  <div class="progress">
    <span class="progress-num"
      >Lépések {{ currentIndex }} / {{ steps.length }}</span
    >
    <div class="progress-bar">
      <div class="bar" :style="'width: ' + percent + '%'"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Status",
  computed: {
    percent() {
      return (this.currentIndex / this.steps.length) * 100;
    },
    currentIndex() {
      return this.$store.getters.getStepIndex + 1;
    },
    steps() {
      return this.$store.getters.getSteps;
    },
    answers() {
      return this.$store.getters.getAnswers;
    }
  }
};
</script>

<style lang="scss">
.progress {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 12px 16px;
  color: $black;
}
.progress-num {
  white-space: nowrap;
  margin-right: 20px;
}
.progress-bar {
  display: block;
  width: 100%;
  height: 10px;
  background: $white;
  border-radius: 5px;
  .bar {
    height: 100%;
    background: $blue;
    border-radius: 5px;
    transition: width 0.4s ease-in-out;
  }
}
</style>
